<script>
	import Layout from "../../layouts/main.vue"
	import ProfilePicture from './ProfilePicture.vue'
	import PersonalInformation from './PersonalInformation.vue'
	import Notifications from './Notifications.vue'
	import axios from 'axios'

  	export default {
    	components: { Layout, ProfilePicture, PersonalInformation, Notifications },    

		props: {
            userDetails: Object,
			userMetaDetails: Object,
			userProfilePhoto: String,
			timeZoneList: Array,
			selectedTimeZone: String,
			notificationDetails: Array,
			hasOtp: Object,
			hasProfilePhoto: Boolean
		},
		data() {
			return {
				title: this.$page.props.auth.user.user_type_text + " - Profile",
				formData: {
					name: null,
					timezone: null,
					notifications: null
				},
				
				errors: {
					name: null,
					timezone: null,
				},
				submitButtonText: 'Save'
			};
		},
		computed: {
            userID() {
				return this.$page.props.auth.user.user_id;
			},
			userType() {
				return this.$page.props.auth.user.user_type;
			},
			userTypeAbbr() {
				return this.$page.props.auth.user.user_type_abbr;
			}
            
		},
		mounted() {
            this.formData.name = this.userDetails.name
            this.formData.timezone = this.timeZoneList.find(option => option.text === this.selectedTimeZone)
        },
        methods: {
            handleUpdateFormSubmit() {
				this.$refs.topProgress.start()
				this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`
				this.formData.notifications = this.notificationDetails
				this.errors = {
					name: null,
					timezone: null
				}
				axios.post(
					route('tp-profile-update'),
					this.formData, {})
				.then(response => {
					this.$toastr.s(response.data.message)
					this.$refs.topProgress.done()
					this.submitButtonText = `Save`
				})
				.catch(err => {
					if(err.response.status == 422) {
						for(const key in err.response.data.errors) {
							this.errors[key] = err.response.data.errors[key] ? err.response.data.errors[key][0] : null
						}
					}
					if(err.response.status == 400) {
						this.$toastr.e(err.response.data.message)
					}
					this.$refs.topProgress.done()
					this.submitButtonText = `Save`
				})
			}
        }
  	}
</script>

<template>
  	<Layout>
		<Head :title="title" />
		<vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0 font-size-18">Profile View & Edit</h4>
				</div>
			</div>
		</div>
		<ProfilePicture 
			:userProfilePhoto="userProfilePhoto" 
			:hasProfilePhoto ="hasProfilePhoto"
			:userDetails="userDetails"
		/>
		<PersonalInformation 
			:formData="formData"
			:errors="errors"
			:userDetails="userDetails"
			:timeZoneList="timeZoneList"
			:hasOtp="hasOtp"
		/>
		<Notifications 
			:notificationDetails="notificationDetails"
		/>
		<div class="text-center">
			<button type="button" class="btn btn-success waves-effect waves-light w-lg" @click="handleUpdateFormSubmit" v-html="submitButtonText" :disabled="submitButtonText != 'Save'">
			</button>
		</div>
  	</Layout>
</template>
